import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type SeatingChartChairProps = CreateIconComponentProps;
export const SeatingChartChairIcon: React.FC<SeatingChartChairProps> = ({
  title = 'Chair',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      d="M18 12.7106L12 9.33563L6 12.7106V19.4606"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 19.3919V5.51062L12 2.13562V9.33562"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.0856L18 12.7106"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.0856V22.8356"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.0856L6 12.7106"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);
